import { DEFAULT_ALLOCATIONS } from '../constants'
import {
    AiRecommendation,
    FunnelMetrics,
    SeasonProgressApi,
    SeasonProgressMetrics,
    TokenAllocations,
} from '../types/leasingSeason.types'

/** Demo-only expected pace marker until lease integration ships. Remove with real pace. */
export const DEMO_EXPECTED_PACE_PERCENT = 80

/** Safe zeroed progress when detail loaded but progress payload is missing. */
export function buildFallbackProgress(): SeasonProgressMetrics {
    return {
        totalCapacity: 0,
        signedNew: 0,
        signedRenewals: 0,
        leasedCount: 0,
        percentLeased: 0,
        daysTotal: 1,
        daysElapsed: 0,
        daysRemaining: 0,
        expectedPercent: 0,
        paceDelta: 0,
        bedsToGoal: 0,
        onPace: true,
        behindBig: false,
        isStub: true,
    }
}

export function applyDemoProgressOverrides(
    metrics: SeasonProgressMetrics,
): SeasonProgressMetrics {
    // Real progress from the API already includes pace; only override stubs.
    if (!metrics.isStub) {
        return metrics
    }

    const expectedPercent = DEMO_EXPECTED_PACE_PERCENT
    const paceDelta = metrics.percentLeased - expectedPercent

    return {
        ...metrics,
        isStub: false,
        expectedPercent,
        paceDelta,
        onPace: paceDelta >= -3,
        behindBig: paceDelta < -10,
    }
}

export function buildDemoAiRecommendation(): AiRecommendation {
    return {
        title: 'Balanced allocation',
        body: 'Recommended token split for this stage of your leasing season.',
        target: { ...DEFAULT_ALLOCATIONS },
    }
}

export function mapFunnelMetrics(
    apiProgress: SeasonProgressApi | undefined,
): FunnelMetrics {
    const funnel = apiProgress?.funnel
    return {
        prospects: funnel?.prospects ?? 0,
        enriched: funnel?.enriched ?? 0,
        inCampaign: funnel?.in_campaign ?? 0,
        leads: funnel?.leads ?? 0,
        applications: funnel?.applications ?? 0,
    }
}

export function loriTargetForLever(
    key: keyof TokenAllocations,
    recommendation: AiRecommendation,
): number {
    return recommendation.target[key]
}
